import parse from 'html-react-parser';


export const getPrice = (shopifyCheckout, price) =>
  Intl.NumberFormat(undefined, {
    currency: shopifyCheckout.currencyCode ? shopifyCheckout.currencyCode : 'USD',
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(parseFloat(price || 0))

export const getVariantColor = variant => {
  const color = variant.selectedOptions.filter(option => option.name.toLowerCase() === 'color')
  // return variant.selectedOptions[1].value
  if (color[0]) {
    return color[0].value
  }
  return ''
}

export const getVariantSize = variant => {
  const size = variant.selectedOptions.filter(option => option.name.toLowerCase() === 'size')
  // return variant.selectedOptions[1].value
  if (size[0]) {
    return size[0].value
  }
  return ''
}

// SEO Helpers
export const getSEO = productDescription => {
  const seo = {}
  const descString = productDescription.replace(/<(.|\n)*?>/g, '')

  const getStringBetween = (string, wordOne, wordTwo) => {
    const startIdx = string.lastIndexOf(wordOne) + wordOne.length + 1
    const endIdx = string.indexOf(wordTwo) - 1
    const foundString = string.substring(startIdx, endIdx)
    return foundString
  }

  seo.title = getStringBetween(descString, 'Meta title:', 'Meta description:')
  seo.description = getStringBetween(descString, 'Meta description:', '---/')

  return seo
}

export const getHTMLDescription = description => {
  if (description) return parse(description.split('---/</p>')[1]);
  return '';
}
